import styled, { css } from 'styled-components';

export const Wrapper = styled.section`
  min-height: 400px;
  padding: 24px;
`;

export const Title = styled.h3`
  ${({ theme }) => css`
    color: ${theme.palette.grey.dark};
    font-size: ${theme.font.sizes.lg};
    font-weight: ${theme.font.weights.medium};
    margin: 0 0 24px 0;
  `}
`;

export const Warning = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.palette.error.ultralight};
    border-radius: 5px;
    display: inline-flex;
    flex-direction: column;
    margin-top: 24px;
    padding: 24px;
    position: relative;
  `}
`;

export const Attention = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;

    svg {
      fill: ${theme.palette.error.primary};
    }
  `}
`;

export const Description = styled.div``;

export const AttentionCancelSignatureLabel = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;

    strong{
      font-weight: ${theme.v2.font.weights.bold} !important;
    }    
  `}
`;

export const AttentionCancelExclusionLabel = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 4px 0 0 0;

    strong{
      font-weight: ${theme.v2.font.weights.bold} !important;
    }    
  `}
`;

export const ListWrapper = styled.div`
  margin: 8px 0;
`;

export const ListTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0 0 8px 0;
  `}
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ListItem = styled.li`
  ${({ theme }) => css`
    position: relative;
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    padding: 0;
    list-style: disc;
    margin-left: 26px;

    strong{
      font-weight: ${theme.v2.font.weights.bold} !important;
    }
  `}
`;
